import { createFileRoute } from "@tanstack/react-router";
import { ModuleGuard } from "@/components/auth/ModuleGuard";
import Contacts from "@/pages/Contacts";

export const Route = createFileRoute("/_app/contacts")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ModuleGuard module="contacts">
      <Contacts />
    </ModuleGuard>
  );
}
